import { studioToScreen, screenToStudio } from "@logic/lib/design"
import type { Node2d } from "@logic/lib/mesh"
import type { GetRecoilValue } from "recoil"
import { DefaultValue, selectorFamily } from "recoil"

import { molecule } from "~/utils/recoil"

import { getRandomPoint } from "../../utils"
import { zoomState } from "../view"

export const [findNodeState, nodeIndex, allNodesState] = molecule<
  Node2d,
  string
>({
  key: `node`,
  default: () => getRandomPoint(),
})

export const projectNode = (get: GetRecoilValue, nodeId: string): Node2d => {
  const nodeState = findNodeState(nodeId)
  const node = get(nodeState)
  const zoom = get(zoomState)

  return studioToScreen.point(node, zoom)
}

export const findProjectedNodeState = selectorFamily<Node2d, string>({
  key: `projectedNode`,
  get:
    (nodeId) =>
    ({ get }): Node2d =>
      projectNode(get, nodeId),
  set:
    (nodeId) =>
    ({ get, set }, computedNode) => {
      if (computedNode instanceof DefaultValue) return
      const { x, y } = computedNode
      const zoom = get(zoomState)
      set(findNodeState(nodeId), screenToStudio.point({ x, y }, zoom))
    },
})
